import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromUserProfile from '../reducers/user-profile.reducer';
import { AuthorizationGroups } from 'src/app/util/groups.enum';

const selectUserProfileState = createFeatureSelector<fromUserProfile.State>(fromUserProfile.userProfileFeatureKey);

export const selectUserProfile = createSelector(selectUserProfileState, state => state.profile);
export const selectRoles = createSelector(selectUserProfile, profile => profile?.roles);
export const selectHasAllRoles = (roles: AuthorizationGroups[]) => createSelector(selectRoles, userRoles => roles.every(r => userRoles?.includes(r)));
export const selectHasAnyRole = (roles: AuthorizationGroups[]) => createSelector(selectRoles, userRoles => roles.filter(r => userRoles?.includes(r)).length > 0);

export const selectIsAdmin = createSelector(selectHasAnyRole([AuthorizationGroups.ITAdmins, AuthorizationGroups.FittingsAdmin, AuthorizationGroups.ClosuresAdmin]), res => !!res);

export const selectMenu = createSelector(selectUserProfileState, state => state.menuItems);
export const selectDashboard = createSelector(selectUserProfileState, state => state.dashboardItems);
export const selectHasLoadedProfile = createSelector(selectUserProfileState, state => state.hasLoadedUser);

export const selectClaims = createSelector(selectUserProfile, profile => profile?.claims);
export const selectClaim = (key: string) => createSelector(selectClaims, claims => (claims || {} as any)[key]);


// we could add a setting scoped to a user to let them have a default companyAccess
export const selectCompanyAccess = createSelector(selectUserProfile, profile => (profile?.companyAccesses || []).find((v, i, a) => i === 0));

export const selectAppConfig = (key: string) => createSelector(selectUserProfileState, state => state.appConfig.find(f => f.paramName === key))
export const selectAppConfigValue = (key: string) => createSelector(selectAppConfig(key), config => {
  switch (config?.dataType) {
    case 'BOOLEAN':
      return config?.paramValue === '1';
    case 'NUMBER':
      return +config.paramValue;
    default:
      return config?.paramValue;
  }
});
